import React, { useEffect, useContext, useRef, useState } from "react";
import KeyboardEventHandler from "react-keyboard-event-handler";
import { useHistory } from "react-router-dom";

import { Box, Button } from "@material-ui/core";
import { useSnackbar } from "notistack";

import { AppContext } from "../../app/context";
import {
  DialogoContadorCedulas,
  LabelTeclasAtalho,
  LabelCaixa,
  DialogoConfirmacao,
  DialogoConsultorPrecos,
  DialogoSenha,
  DialogoAutorizacaoRetirada,
} from "../../components";
import {
  getCaixaId,
  getSessionId,
  getUsername,
  api,
  logout,
  imprimirRelatorioCaixa,
  imprimirTroco,
  getListAllAPI,
  getVendaCancelada,
  setVendaCancelada,
  getUuidVendaRascunho,
  getUserId,
  imprimirComprovanteTef,
  imprimirNotaVenda
} from "../../services";
import {
  formatMoeda,
  ATALHO_OPEN_MENU,
  ATALHO_AVANCAR,
  ATALHO_VOLTAR,
  MALOTE_TROCO_OPTION,
  MALOTE_SUBMALOTE_OPTION,
  INCLUIR_TOKEN_TLS_FISERV,
  ArredondamentoHalfUp,
} from "../../utils";
import DialogoTrocoEntrada from "./DialogoTrocoEntrada";
import MenuMaisOpcoes from "./MenuMaisOpcoes";
import DialogoRetirada from "./DialogoRetirada";
import DialogoAutorizacaoComQrcode from "../../components/Dialogos/DialogoAutorizacao";
import DialogoVideosTutoriais from "./DialogoVideosTutoriais";
import DialogoPagarDescarregoMercadoria from "./DialogoPagarDescarregoMercadoria";
import getInterfaceSitef from "../../services/sitef/interface";

import DialogoComunicacaoSitef from "../CreateVenda/_SubPages/Parcelas/DialogoComunicacaoSitef";
import DialogoTratamentoTEFPendentes from "./DialogoTratamentoTEFPendentes";
import DialogoStatusImpressao from '../CreateVenda/_SubPages/Parcelas/DialogoComunicacaoSitef/DialogoStatusImpressao'

const NOVA_VENDA_ACTION = ATALHO_AVANCAR;
const CARREGAR_VENDA_SALVA_ACTION = "ctrl+l";
const NOVA_RETIRADA_ACTION = "F10";
const OPEN_MENU_ACTION = ATALHO_OPEN_MENU;
const LOGOUT_ACTION = ATALHO_VOLTAR;
const CONSULTOR_PRECOS_ACTION = "F3";
const NOVA_PREVENDA_ACTION = "F2";
const NOVO_DEPOSITO_ACTION = "F9";
const ESC_ACTION = "esc";

const DESCONECTAR_SESSAO_ACTION = "F11";

const tempoPing = 5 * 1000;

const PAGAR_DESCARREGO_MERCADORIA_ACTION = "F1";

const REIMPRIMIR_ULTIMO_CUPOM = "F7";

const IMPRIMIR_ULTIMO_CUPOM_TEF_ACTION = "F6";

const IMPRIMIR_CUPOM_ESPECIFICO = "F12";

const CANCELAR_TRANSACAO_TEF = "Delete";

const MENU_ADMINISTRATIVO_TEF = "Shift";

const Init = () => {
  const refDialogoAutorizacaoComQrcode = useRef(null);
  const [dialogoAutorizacaoConfig, setDialogoAutorizacaoConfig] = useState({
    title: "",
    mensagemSucesso: "",
    handleSalvar: () => {},
  });
  const refDialogoTrocoEntrada = useRef(null);
  const refDialogoSenha = useRef(null);
  const refDialogoRetirada = useRef(null);
  const refDialogoSenha2 = useRef(null);
  const refDialogoVideosTutoriais = useRef(null);
  const refDialogoContadorCedulas = useRef(null);
  const refDialogoPagarDescarregoMercadoria = useRef(null);
  const refDialogoNovaVendaRascunho = useRef(null);
  const history = useHistory();
  const menuRef = useRef(null);
  const dialogoLogoutRef = useRef(null);
  const refDialogoStatusImpressao = useRef(null)
  const { enqueueSnackbar } = useSnackbar();
  const {
    dispatch,
    app: {
      saldoCaixa,
      mensagemInicialFc,
      saldoIndicadorRetirada,
      modoOffline,
      isBuscouDadosPermissoes,
      criarVendaPermissao,
      criarPedidoPermissao,
      criarRetiradaPermissao,
      consultarPrecosPermissao,
      utilizarTrocoPermissao,
      tipoCaixa,
      nomeCaixa,
      pagarDescarregoMercadoriaPermissao,
      IdTerminalSitef,
      IPSiTef,
      IdLoja,
      cnpjAC,
      cnpjEstabelecimento,
      tokenTlsFiserv,
      pendenciasTEFResolvidas,
      usar_tef,
      usar_nova_impressao,
      contador_atualizacao_info_tef,
      usar_biometria,
      interfaceSitef
    },
    openConsultorPrecos,
  } = useContext(AppContext);
  const [responsavelId, setResponsavelId] = useState(0);

  const refControleRetirada = useRef(false);
  const refControleDeposito = useRef(false);
  const refControleLogout = useRef(false);

  const refDialogoComunicacaoSitef = useRef(null);

  const refControlePendencias = useRef(false);
  const refDialogoTratamentoTEFPendentes = useRef(null);
  const [idTerminalSitefCarregado, setIdTerminalSitefCarregado] = useState(false);

  function updateInterfaceSitef(interfaceSitef) {
    dispatch({
      type: "UPDATE_INTERFACE_SITEF",
      interfaceSitef
    });
  }

  async function getPermissoes() {
    try {
      const response = await api.get(
        `permissoes_frente_caixa/${getSessionId()}`
      );
      const dados = formatPermissoes(response.data);
      dispatch({
        type: "UPDATE_PERMISSOES",
        criarVendaPermissao: dados.criarVendaPermissao,
        consultarPrecosPermissao: dados.consultarPrecosPermissao,
        utilizarTrocoPermissao: dados.utilizarTrocoPermissao,
        utilizarTrocoAberturaCaixaPermissao:
          dados.utilizarTrocoAberturaCaixaPermissao,
        criarPedidoPermissao: dados.criarPedidoPermissao,
        criarRetiradaPermissao: dados.criarRetiradaPermissao,
        carregarPedidoPermissao: dados.carregarPedidoPermissao,
        criarClientePermissao: dados.criarClientePermissao,
        editarClientePermissao: dados.editarClientePermissao,
        tipoPagamentoDinheiroPermissao: dados.tipoPagamentoDinheiroPermissao,
        tipoPagamentoCartaoCreditoPermissao:
          dados.tipoPagamentoCartaoCreditoPermissao,
        tipoPagamentoCartaoDebitoPermissao:
          dados.tipoPagamentoCartaoDebitoPermissao,
        tipoPagamentoPixQrcodePermissao: dados.tipoPagamentoPixQrcodePermissao,
        tipoPagamentoVoucherPermissao: dados.tipoPagamentoVoucherPermissao,
        tipoPagamentoDevolucaoPermissao: dados.tipoPagamentoDevolucaoPermissao,
        tipoPagamentoPixDistanciaPermissao:
          dados.tipoPagamentoPixDistanciaPermissao,
        tipoPagamentoCreditoFidelidadePermissao:
          dados.tipoPagamentoCreditoFidelidadePermissao,
        pesquisaPorNomes: dados.pesquisaPorNomes,
        tipoCaixa: dados.tipoCaixa,
        nomeCaixa: dados.nomeCaixa,
        pesquisaPorCodigoDeBalancaPermissao:
          dados.pesquisaPorCodigoDeBalancaPermissao,
        conferenciaGrandesPesagensPermissao:
          dados.conferenciaGrandesPesagensPermissao,
        pagarDescarregoMercadoriaPermissao:
          dados.pagarDescarregoMercadoriaPermissao,
      });
    } catch (e) {
      enqueueSnackbar("INTERNET: ERRO AO OBTER AS PERMISSÕES!", {
        variant: "error",
      });
    }
  }

  function formatPermissoes(permissoes) {
    const permissoesInit = {
      criarVendaPermissao: false,
      consultarPrecosPermissao: false,
      utilizarTrocoPermissao: false,
      utilizarTrocoAberturaCaixaPermissao: false,
      criarPedidoPermissao: false,
      criarRetiradaPermissao: false,
      carregarPedidoPermissao: false,
      criarClientePermissao: false,
      editarClientePermissao: false,
      tipoPagamentoDinheiroPermissao: false,
      tipoPagamentoCartaoCreditoPermissao: false,
      tipoPagamentoCartaoDebitoPermissao: false,
      tipoPagamentoPixQrcodePermissao: false,
      tipoPagamentoVoucherPermissao: false,
      tipoPagamentoDevolucaoPermissao: false,
      tipoPagamentoPixDistanciaPermissao: false,
      tipoPagamentoCreditoFidelidadePermissao: false,
      pesquisaPorNomes: false,
      tipoCaixa: "",
      nomeCaixa: "",
      pesquisaPorCodigoDeBalancaPermissao: false,
      conferenciaGrandesPesagensPermissao: false,
      pagarDescarregoMercadoriaPermissao: false,
    };

    if (permissoes) {
      permissoesInit.criarVendaPermissao = permissoes.criar_venda;
      permissoesInit.consultarPrecosPermissao = permissoes.consultar_precos;
      permissoesInit.utilizarTrocoPermissao = permissoes.utilizar_troco;
      permissoesInit.utilizarTrocoAberturaCaixaPermissao =
        permissoes.utilizar_troco_abertura_caixa;
      permissoesInit.criarPedidoPermissao = permissoes.criar_pedido;
      permissoesInit.criarRetiradaPermissao = permissoes.criar_retirada;
      permissoesInit.carregarPedidoPermissao = permissoes.carregar_pedido;
      permissoesInit.criarClientePermissao = permissoes.criar_cliente;
      permissoesInit.editarClientePermissao = permissoes.editar_cliente;
      permissoesInit.tipoPagamentoDinheiroPermissao =
        permissoes.tipo_pagamento_dinheiro;
      permissoesInit.tipoPagamentoCartaoCreditoPermissao =
        permissoes.tipo_pagamento_cartao_credito;
      permissoesInit.tipoPagamentoCartaoDebitoPermissao =
        permissoes.tipo_pagamento_cartao_debito;
      permissoesInit.tipoPagamentoPixQrcodePermissao =
        permissoes.tipo_pagamento_pix_qrcode;
      permissoesInit.tipoPagamentoVoucherPermissao =
        permissoes.tipo_pagamento_voucher;
      permissoesInit.tipoPagamentoDevolucaoPermissao =
        permissoes.tipo_pagamento_devolucao;
      permissoesInit.tipoPagamentoPixDistanciaPermissao =
        permissoes.tipo_pagamento_pix_distancia;
      permissoesInit.tipoPagamentoCreditoFidelidadePermissao =
        permissoes.tipo_pagamento_credito_fidelidade;
      permissoesInit.pesquisaPorNomes = permissoes.pesquisa_por_nomes;
      permissoesInit.tipoCaixa = permissoes.nome;
      permissoesInit.nomeCaixa = permissoes.nomeCaixa;
      permissoesInit.pesquisaPorCodigoDeBalancaPermissao =
        permissoes.pesquisa_por_codigo_de_balanca;
      permissoesInit.conferenciaGrandesPesagensPermissao =
        permissoes.conferencia_grandes_pesagens;
      permissoesInit.pagarDescarregoMercadoriaPermissao =
        permissoes.pagar_descarrego_mercadoria;
    }

    return permissoesInit;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      if (!isBuscouDadosPermissoes) {
        getPermissoes();
      }
    }, tempoPing);
    return () => clearInterval(timer);
  });

  useEffect(() => {
    getPermissoes();
  }, []);

  async function getConfigFidelidade() {
    try {
      const response = await api.get(
        `config_sistema_fidelidade` //ajeitar
      );
      const dados = response.data;
      dispatch({
        type: "UPDATE_CONFIG_SISTEMA_FIDELIDADE",
        valor_venda_com_taxa_sistema_fidelidade: dados.valor_venda_com_taxa_sistema_fidelidade,
        valor_venda_sem_taxa_sistema_fidelidade: dados.valor_venda_sem_taxa_sistema_fidelidade,
      });
    } catch (e) {
      enqueueSnackbar("INTERNET: ERRO AO OBTER CONFIGURAÇÕES DO SISTEMA FIDELIDADE!", {
        variant: "error",
      });
    }
  }

  useEffect(() => {
    getConfigFidelidade();
  }, []);

  async function configurarInterfaceSitef() {
    if(usar_tef && !interfaceSitef) {
      let trnAdditionalParametersSufixo = "";

      let trnInitParameters = `[ParmsClient=1=${cnpjEstabelecimento};2=${cnpjAC}]`;

      if (INCLUIR_TOKEN_TLS_FISERV) {
        if (tokenTlsFiserv) {
          trnAdditionalParametersSufixo = trnAdditionalParametersSufixo
            ? `${trnAdditionalParametersSufixo};{TipoComunicacaoExterna=TLSGWP};{TokenRegistro=${tokenTlsFiserv}}`
            : `{TipoComunicacaoExterna=TLSGWP};{TokenRegistro=${tokenTlsFiserv}}`;
        }
      }

      const config = {
        sitefIp: IPSiTef,
        lojaId: IdLoja,
        terminalId: IdTerminalSitef,
        cashierOperator: `sessao ${getSessionId()}`,
        trnAdditionalParametersSufixo,
        trnInitParameters,
      };

      if (
        IPSiTef &&
        IdLoja &&
        IdTerminalSitef &&
        cnpjEstabelecimento &&
        cnpjAC &&
        tokenTlsFiserv
      ) {
        const interfaceSitef = getInterfaceSitef({}, config);

        try {
          await interfaceSitef.verificaEstadoInicial()
          updateInterfaceSitef(interfaceSitef)
        } catch (error) {
          enqueueSnackbar(error ? error.toString() : 'ERROR', {
            variant: "error",
          });
        }
      }
    }
  }

  useEffect(() => {
    configurarInterfaceSitef()
  }, [
    IPSiTef,
    IdLoja,
    IdTerminalSitef,
    cnpjEstabelecimento,
    cnpjAC,
    tokenTlsFiserv,
    usar_tef,
  ]);

  function openDialogoTratamentoTEFPendentes(transacoes) {
    if(refDialogoTratamentoTEFPendentes.current) {
      refDialogoTratamentoTEFPendentes.current.handleOpen(transacoes)
    }
  }

  function formatDateTEF(date) {
    if (!date) return '';

    const str = date.toString();

    return `${str.substr(6, 2)}/${str.substr(4, 2)}/${str.substr(0, 4)}`;
  }

  function formatTimeTEF(time) {
    if (!time) return '';

    const str = time.toString().padStart(6, '0');

    return `${str.substr(0, 2)}:${str.substr(2, 2)}:${str.substr(4, 2)}`;
  }

  function formatMoney(value) {
    if (!value) return 'R$ 0,00';

    return (value / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function agruparTransacoes(lista) {
    const grupos = {};

    for (const pend of lista) {
      const cupomFiscal = pend["160"];
      const dataFiscal = pend["163"];
      const horaFiscal = pend["164"];
      const valor = pend["1319"]

      const chave = `${cupomFiscal}_${dataFiscal}`;

      if (!grupos[chave]) {
        grupos[chave] = {
          cupomFiscal,
          dataFiscal,
          horaFiscal,
          transacoes_cupom: [],
        };
      }

      grupos[chave].transacoes_cupom.push({
        cupomFiscal,
        dataFiscal,
        horaFiscal,
        valor
      });

    }

    return Object.values(grupos);
  }

  useEffect(() => {
    async function tratarTransacoesTefPendentes() {
      let transacoes = []
      if (!refControlePendencias.current) {
        refControlePendencias.current = true;
        openDialogoTratamentoTEFPendentes(transacoes)

        const pendentes = await refDialogoComunicacaoSitef.current.getTransacoesPendentes(
          {
            confirma: 0,
          },
          interfaceSitef
        );

        if (pendentes.status) {
          
          /* const pendentesFinal = pendentes.data.filter(
            (item) => item["161"] == "0"
          );

          for (let i = 0; i < pendentesFinal.length; i++) {
            const pend = pendentesFinal[i];

            transacoes.push({
              cupomFiscal: pend["160"],
              dataFiscal: formatDateTEF(pend["163"]),
              horaFiscal: formatTimeTEF(pend["164"]),
              valor: formatMoney(pend["1319"]),
            })

            const { status, data, message } = await interfaceSitef.finishTransaction({
              cupomFiscal: pend["160"],
              dataFiscal: pend["163"],
              horaFiscal: pend["164"],
              confirma: 0,
            });

            openDialogoTratamentoTEFPendentes([...transacoes])
          } */

          const pendentesFinal = agruparTransacoes(pendentes.data)

          for (let i = 0; i < pendentesFinal.length; i++) {

            const {
              cupomFiscal,
              dataFiscal,
              horaFiscal,
              transacoes_cupom
            } = pendentesFinal[i]

            const { status, data, message } = await interfaceSitef.finishTransaction({
              cupomFiscal,
              dataFiscal,
              horaFiscal,
              confirma: 0,
            });

            for(let j = 0; j < transacoes_cupom.length; j++) {
              const pend = transacoes_cupom[j];

              transacoes.push({
                cupomFiscal: pend["cupomFiscal"],
                dataFiscal: formatDateTEF(pend["dataFiscal"]),
                horaFiscal: formatTimeTEF(pend["horaFiscal"]),
                valor: formatMoney(pend["valor"]),
              })
            }

            openDialogoTratamentoTEFPendentes([...transacoes])
          }

          const { status, data, message } = await interfaceSitef.finishTransaction({
            cupomFiscal: pendentes.dadosFiscais.CupomFiscal,
            dataFiscal: pendentes.dadosFiscais.DataFiscal,
            horaFiscal: pendentes.dadosFiscais.HoraFiscal,
            confirma: 1,
          });

          marcarPendenciasTefComoResolvidas()
          refControlePendencias.current = false;
        } else {
          enqueueSnackbar(pendentes.message, {
            variant: "error",
          });
        }
      } else {
        refControlePendencias.current = true;
      }
    }

    /*const statePinPad = await interfaceSitef.getStatePinPad(interfaceSitef.getSessionId())
    if (statePinPad.serviceStatus !== 0) {
      throw `Erro Pinpad: ${statePinPad.serviceMessage}`
    }

    if (!statePinPad.clisitefStatus) {
      throw 'PinPad não presente'
    } */

    if (interfaceSitef && pendenciasTEFResolvidas && idTerminalSitefCarregado) {
      if(usar_tef) {
        tratarTransacoesTefPendentes();
      } else {
        marcarPendenciasTefComoResolvidas()
        refControlePendencias.current = false;
      }
    } else {
      if(pendenciasTEFResolvidas && idTerminalSitefCarregado) {
        marcarPendenciasTefComoResolvidas()
        refControlePendencias.current = false;
      }
    }

  }, [interfaceSitef, usar_tef, idTerminalSitefCarregado]);

  function updateSaldo() {
    dispatch({
      type: "UPDATE_SALDO_CAIXA",
    });
  }

  function marcarPendenciasTefComoResolvidas() {
    dispatch({
      type: "MARCAR_PENDENCIAS_TEF_COMO_RESOLVIDAS",
    });
  }

  useEffect(() => {
    updateSaldo();
  }, []);

  async function obterIdTerminalSitef() {
    const response = await api.get(`/obter-id-terminal-sitef/${getCaixaId()}`);
    const data = response.data;
    if (data) {
      dispatch({
        type: "UPDATE_IDTERMINALSITEF",
        IdTerminalSitef: data.IdTerminalSitef,
        tokenTlsFiserv: data.tokenTlsFiserv,
        usar_tef: data.usar_tef,
        usar_nova_impressao: data.usar_nova_impressao,
        contador_atualizacao_info_tef: contador_atualizacao_info_tef,
        //usar_biometria: data.usar_biometria
      });

      setIdTerminalSitefCarregado(true)
    }
  }

  useEffect(() => {
    obterIdTerminalSitef();
  }, []);

  function changeModoOffline() {
    dispatch({ type: "CHANGE_MODO_OFFLINE", modoOffline: !modoOffline });
  }

  async function novaRetirada(valor, objCedulas, userId, transportador_id, uuid) {
    if (!refControleRetirada.current) {
      refControleRetirada.current = true;
      try {
         abrirDialogoStatusImpressao('Aguarde...', 'Registrando Retirada...')
        const transferencia = await api.post("/malote_sessoes/retirada", {
          nome: "",
          valor,
          sessao_id: getSessionId(),
          conta_id: getCaixaId(),
          categoria_transacao_2_id: null,
          status: true,
          tipo: "Transferência",
          conta_destino_id: 1,
          repetir: false,
          vezesRepetir: 1,
          tipoPeriodo: "Mensal",
          notas: objCedulas,
          responsavel_id: userId,
          transportador_id,
          uuid,
        });
        updateSaldo();
        setResponsavelId(0);
        abrirDialogoStatusImpressao('Aguarde...', 'Imprimindo Comprovante de Retirada..')
        const codigo = await imprimirTroco(transferencia.data.id, modoOffline, usar_nova_impressao);
        if (codigo < 0) {
          enqueueSnackbar("Erro ao imprimir a nota da retirada!", {
            variant: "error",
          });
        }
      } catch (erros) {
        enqueueSnackbar("INTERNET: ERRO AO REGISTRAR A RETIRADA!", {
          variant: "error",
        });
      } finally {
        fecharDialogoStatusImpressao()
        refControleRetirada.current = false;
      }
    }
  }

  async function imprimirUltimoCupomTef() {
      if (refDialogoComunicacaoSitef.current) {
        refDialogoComunicacaoSitef.current.imprimirUltimoCupom();
      }
  }

  async function imprimirCupomEspecifico() {
    if (refDialogoComunicacaoSitef.current) {
      refDialogoComunicacaoSitef.current.imprimirCupomEspecifico();
    }
  }

  async function cancelarTransacaoTef() {
    if (refDialogoComunicacaoSitef.current) {
      refDialogoComunicacaoSitef.current.cancelarTransacaoTef();
    }
  }

  function getOpenDialogoComunicacaoSitef() {
    let podeVoltar = true;
    if (refDialogoComunicacaoSitef) {
      if (refDialogoComunicacaoSitef.current) {
        if (refDialogoComunicacaoSitef.current.getOpen) {
          if (refDialogoComunicacaoSitef.current.getOpen()) {
            podeVoltar = false;
          }
        }
      }
    }

    return podeVoltar;
  }

  async function menuAdministrativoTef() {
    if (refDialogoComunicacaoSitef.current) {
      refDialogoComunicacaoSitef.current.menuAdministrativo();
    }
  }

  function abrirDialogoAutorizacaoComQrcode({
    title,
    mensagemSucesso,
    handleSalvar,
    codigo = 1,
  }) {
    setDialogoAutorizacaoConfig({ title, mensagemSucesso, handleSalvar });
    if (refDialogoAutorizacaoComQrcode.current) {
      refDialogoAutorizacaoComQrcode.current.handleOpen(codigo);
    }
  }

  function handleActions(action) {
    if (!pendenciasTEFResolvidas) {
      if (getOpenDialogoComunicacaoSitef()) {
        switch (action) {
          case NOVA_VENDA_ACTION:
            if (criarVendaPermissao) {
              if (getUuidVendaRascunho()) {
                if (refDialogoNovaVendaRascunho.current) {
                  refDialogoNovaVendaRascunho.current.handleOpen(
                    "Venda em rascunho encontrada!",
                    "Existe uma venda salva em rascunho. Deseja mesmo iniciar uma nova venda?",
                    0,
                    "Cancelar",
                    "Iniciar Nova Venda"
                  );
                }
              } else {
                history.push("/vendas/frentedecaixa");
              }
            }
            break;
          case CARREGAR_VENDA_SALVA_ACTION:
            if (criarVendaPermissao && getUuidVendaRascunho()) {
              abrirDialogoAutorizacaoComQrcode({
                title: "Autorização do Gerente para Carregar Venda Salva!",
                mensagemSucesso: "Venda salva carregada com sucesso!",
                handleSalvar: () => {
                  history.push({
                    pathname: "/vendas/frentedecaixa",
                    state: { carregarVendaSalva: true },
                  });
                },
              });
            }
            break;
          case NOVA_PREVENDA_ACTION:
            if (criarPedidoPermissao) history.push("/pre_vendas/frentedecaixa");
            break;
          case NOVA_RETIRADA_ACTION:
            if (criarRetiradaPermissao) {
              if (refDialogoRetirada.current) {
                refDialogoRetirada.current.handleOpen();
              }
            }
            break;
          case CONSULTOR_PRECOS_ACTION:
            if (consultarPrecosPermissao) {
              openConsultorPrecos();
            }
            break;
          case OPEN_MENU_ACTION:
            if (refDialogoVideosTutoriais.current) {
              refDialogoVideosTutoriais.current.handleOpen();
            }
            break;
          case NOVO_DEPOSITO_ACTION:
            if (utilizarTrocoPermissao) {
              if (refDialogoTrocoEntrada.current) {
                refDialogoTrocoEntrada.current.handleOpen();
              }
            }
            break;
          case LOGOUT_ACTION:
            abrirDialogoAutorizacaoComQrcode({
              title: "Autorização logout!",
              mensagemSucesso: "Logout realizado!",
              handleSalvar: () => {
                logoutTaskExec();
              },
            });
            break;
          case DESCONECTAR_SESSAO_ACTION:
            abrirDialogoAutorizacaoComQrcode({
              title: "Desconectar Sessão!",
              mensagemSucesso: "Desconexão da sessão realizada com sucesso!",
              handleSalvar: () => {
                logout();
                history.push("/login");
              },
              codigo: 0,
            });
            break;
          case ESC_ACTION:
            abrirDialogoAutorizacaoComQrcode({
              title: "Autorização logout!",
              mensagemSucesso: "Logout realizado!",
              handleSalvar: () => {
                logoutTaskExec();
              },
            });
            break;
          case PAGAR_DESCARREGO_MERCADORIA_ACTION:
            if (pagarDescarregoMercadoriaPermissao) {
              if (refDialogoPagarDescarregoMercadoria.current) {
                refDialogoPagarDescarregoMercadoria.current.handleOpen();
              }
            }
            break;
          case REIMPRIMIR_ULTIMO_CUPOM: {
            abrirDialogoAutorizacaoComQrcode({
              title: "Autorização Reimpressão do Último Cupom!",
              mensagemSucesso: "Reimpressão do Último Cupom realizado!",
              handleSalvar: () => {
                imprimirUltimaVenda();
              },
            });
            break;
          }
          case IMPRIMIR_ULTIMO_CUPOM_TEF_ACTION: {
            if(usar_tef) {
              abrirDialogoAutorizacaoComQrcode({
                title: "Autorização Reimpressão do Último Cupom TEF!",
                mensagemSucesso: "Reimpressão do Último Cupom TEF realizado!",
                handleSalvar: () => {
                  imprimirUltimoCupomTef();
                },
              });
            }
            break;
          }
          case IMPRIMIR_CUPOM_ESPECIFICO: {
            if(usar_tef) {
              abrirDialogoAutorizacaoComQrcode({
                title: "Autorização Impressão de Cupom Específico!",
                mensagemSucesso: "Impressão do Cupom Específico realizado!",
                handleSalvar: () => {
                  imprimirCupomEspecifico();
                },
              });
            }
            break;
          }
          case CANCELAR_TRANSACAO_TEF: {
            if(usar_tef) {
              abrirDialogoAutorizacaoComQrcode({
                title: "Autorização Cancelamento de Transação TEF!",
                mensagemSucesso: "Cancelamento da Transação TEF realizado!",
                handleSalvar: () => {
                  cancelarTransacaoTef();
                },
              });
            }
            break;
          }
          case MENU_ADMINISTRATIVO_TEF: {
            if(usar_tef) {
              abrirDialogoAutorizacaoComQrcode({
                title: "Autorização Menu Administrativo TEF!",
                mensagemSucesso: "Acesso ao Menu Administrativo TEF autorizado!",
                handleSalvar: () => {
                  menuAdministrativoTef();
                },
              });
            }
            break;
          }
          default:
            break;
        }
      }
    }
  }

  async function logoutTaskExec() {
    if (!refControleLogout.current) {
      refControleLogout.current = true;
      try {
        abrirDialogoStatusImpressao('Aguarde...', 'Encerrando Sessão...')
        await api.put(`/malote_sessoes/fechar/${getSessionId()}`);
        logout();
        abrirDialogoStatusImpressao('Aguarde...', 'Imprimindo Relatório de Sessão...')
        const codigo = await imprimirRelatorioCaixa(
          getSessionId(),
          modoOffline,
          usar_nova_impressao
        );
        if (codigo < 0) {
          enqueueSnackbar("Erro ao imprimir o relatório!", {
            variant: "error",
          });
        }
        history.push("/login");
      } catch (e) {
        enqueueSnackbar("INTERNET: ERRO AO FECHAR A SESSÃO!", {
          variant: "error",
        });
      } finally {
        fecharDialogoStatusImpressao()
        refControleLogout.current = false;
      }
    }
  }

  function logoutTask() {
    if (saldoCaixa > 2 || saldoCaixa < -2) {
      refDialogoSenha2.current.handleOpen(0);
    } else if (refDialogoSenha2.current) {
      logoutTaskExec();
    }
  }

  async function handleTrocoEntrada(codigo, user_id, transportador_id, uuid) {
    if (!refControleDeposito.current) {
      refControleDeposito.current = true;
      try {
        abrirDialogoStatusImpressao('Aguarde...', 'Registrando Depósito...')
        const data = await getListAllAPI(
          "malote_pacotes",
          ["id", "asc"],
          { codigo },
          []
        );
        if (data.data.length > 0) {
          if (
            data.data.tipo === MALOTE_TROCO_OPTION ||
            data.data.tipo === MALOTE_SUBMALOTE_OPTION
          ) {
            throw "Não existe um troco ou submalote com este código!";
          }
          const troco = await api.post("/malote_sessoes/deposito", {
            user_id,
            transportador2_id: transportador_id,
            troco_id: data.data[0].id,
            sessao_id: getSessionId(),
            conta_id: getCaixaId(),
            uuid,
          });
          abrirDialogoStatusImpressao('Aguarde...', 'Imprimindo Comprovante de Depósito...')
          const codigo = await imprimirTroco(troco.data.idTroco, modoOffline, usar_nova_impressao);
          if (codigo < 0) {
            enqueueSnackbar("Depósito feito com sucesso!", {
              variant: "success",
            });
          }
          if (codigo < 0) {
            enqueueSnackbar("Erro ao imprimir depósito!", {
              variant: "error",
            });
          }
          updateSaldo();
        } else {
          enqueueSnackbar("Este troco não existe ou já foi usado!", {
            variant: "error",
          });
        }
      } catch (erros) {
        enqueueSnackbar("INTERNET: ERRO AO UTILIZAR O TROCO!", {
          variant: "error",
        });
      } finally {
        fecharDialogoStatusImpressao()
        refControleDeposito.current = false;
      }
    }
  }

  function getLabelsAtalhos() {
    const labelsAtalhos = [];

    if (criarPedidoPermissao)
      labelsAtalhos.push({
        atalho: NOVA_PREVENDA_ACTION,
        label: "Novo pedido",
      });
    if (consultarPrecosPermissao)
      labelsAtalhos.push({
        atalho: CONSULTOR_PRECOS_ACTION,
        label: "Cons. Preço",
      });
    labelsAtalhos.push({ atalho: LOGOUT_ACTION, label: "Logout" });
    if (criarVendaPermissao)
      labelsAtalhos.push({ atalho: NOVA_VENDA_ACTION, label: "Nova venda" });
    if (criarVendaPermissao && getUuidVendaRascunho())
      labelsAtalhos.push({
        atalho: CARREGAR_VENDA_SALVA_ACTION,
        label: "Car. Rasc. Venda",
      });
    if (utilizarTrocoPermissao)
      labelsAtalhos.push({
        atalho: NOVO_DEPOSITO_ACTION,
        label: "Novo Depósito",
      });
    if (criarRetiradaPermissao)
      labelsAtalhos.push({
        atalho: NOVA_RETIRADA_ACTION,
        label: "Nova retirada",
      });
    labelsAtalhos.push({
      atalho: DESCONECTAR_SESSAO_ACTION,
      label: "Desconectar",
    });
    labelsAtalhos.push({ atalho: OPEN_MENU_ACTION, label: "Ajuda" });
    if (pagarDescarregoMercadoriaPermissao)
      labelsAtalhos.push({
        atalho: PAGAR_DESCARREGO_MERCADORIA_ACTION,
        label: "Pag. Descarrego",
      });
    labelsAtalhos.push({
      atalho: REIMPRIMIR_ULTIMO_CUPOM,
      label: "Imp. Últ Cupom",
    });
    if (labelsAtalhos.length <= 5) {
      return [labelsAtalhos, []];
    }
    if(usar_tef) {
      labelsAtalhos.push({
        atalho: IMPRIMIR_ULTIMO_CUPOM_TEF_ACTION,
        label: "Imp. Cupom Tef",
      });
    }
    if(usar_tef) {
      labelsAtalhos.push({
        atalho: IMPRIMIR_CUPOM_ESPECIFICO,
        label: "Imp. Cup. TEF",
      });
    }
    if(usar_tef) {
      labelsAtalhos.push({
        atalho: "Del",
        label: "Del. Tran. TEF",
      });
    }
    if(usar_tef) {
      labelsAtalhos.push({
        atalho: "Shift",
        label: "Men. Adm. TEF",
      });
    }
    return [labelsAtalhos.slice(0, 6), labelsAtalhos.slice(6)];
  }

  const mensagemInicialFcFormatada = mensagemInicialFc.replace(
    /\$USER/g,
    getUsername()
  );

  async function handlePagarDescarregoMercadoria(codigo) {
    if (!codigo) {
      enqueueSnackbar(
        "É necessário especificar um código de 13 dígitos para pagar um descarrego de mercadoria!",
        {
          variant: "error",
        }
      );
      return;
    }

    if (codigo.length !== 16) {
      enqueueSnackbar(
        "É necessário especificar um código de 16 dígitos para pagar um descarrego de mercadoria!",
        {
          variant: "error",
        }
      );
      return;
    }

    if (codigo.substring(0, 6) !== "0CFCDM") {
      enqueueSnackbar("O código do descarrego deve começar com '0CFCDM'!", {
        variant: "error",
      });
      return;
    }

    const id = parseInt(codigo.substring(6), 10);

    if (Number.isNaN(id)) {
      enqueueSnackbar("Este código não é válido!", {
        variant: "error",
      });
      return;
    }

    const response = await api.get(`/verifica-descarrego-existente/${id}`);

    const { status, message } = response.data;

    if (!status) {
      enqueueSnackbar(message, {
        variant: "error",
      });
      return;
    }

    history.push(`/pagar_descarrego/nfes?descarrego_id=${id}`);
  }

  async function getIdUltimaVenda() {
    const response = await api.get(
      `/get-id-ultima-venda-checkout/${getSessionId()}`
    );
    const { id, tipoNota } = response.data;
    return { id, tipoNota };
  }

  async function imprimirUltimaVenda() {
    const { id: idUltimaVenda, tipoNota } = await getIdUltimaVenda();
    if (idUltimaVenda > 0) {
      if (tipoNota !== "nfce") {
        enqueueSnackbar(`A última venda não é uma NFCe, não é possível imprimir!`, {
          variant: "error",
        });
        return;
      }
      //imprimir venda aqui
      const codigo = await imprimirNotaVenda(idUltimaVenda, modoOffline, usar_nova_impressao, []);
     /*  const response = {
        status: true,
        message: ''
      } */
 /*      if (response.status) {
        // ta tufo ok
      } else {
        enqueueSnackbar(
          `Erro ao imprimir a nota de venda, verifique o arquivo ${response.message}!`,
          {
            variant: "error",
          }
        );
      } */
    } else {
      enqueueSnackbar(`Nenhuma venda de sessão!`, {
        variant: "error",
      });
    }
  }

  function ArredondamentoHalfUp2(valor, casasDecimais) {
    const fator = Math.pow(10, casasDecimais);
    return Math.round(valor * fator + Number.EPSILON) / fator;
  }

  function formatarValor(valor) {
    const numero =
      typeof valor === "string" ? parseFloat(valor.replace(",", ".")) : valor;

    const arredondado = ArredondamentoHalfUp2(numero, 2);

    const valorFormatado = arredondado.toFixed(2).replace(/[.,]/g, "");

    return valorFormatado;
  }

  async function salvarComprovanteTefCancelamentoTransacao(dadosTef) {
    const response = await api.put("/salvar-comprovante-tef-cancelamento", {
      comprovante: dadosTef["121"],
      identificador: `${dadosTef["515"]}-${dadosTef["516"]}-${formatarValor(
        dadosTef["146"]
      )}-${IdTerminalSitef}`,
    });

    const { status, message, data } = response.data;
  }

  function abrirDialogoStatusImpressao(titulo, corpo) {
    if(refDialogoStatusImpressao.current) {
      refDialogoStatusImpressao.current.handleOpen(titulo, corpo)
    }
  }

  function fecharDialogoStatusImpressao() {
    if(refDialogoStatusImpressao.current) {
      refDialogoStatusImpressao.current.handleFechar()
    }
  }

  function handleConfirmaNovaVendaComRascunho(codigo) {
    history.push("/vendas/frentedecaixa");
  }

  return (
    <>
      <Box margin="10px" />
      <Box display="flex" justifyContent="space-between" padding="10px">
        <Box flex={6}>
          <div
            style={{
              height: "100% ",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <h4
              style={{
                color: "white",
                fontSize: "25px",
                maxWidth: "40vw",
                textAlign: "center",
              }}
            >
              {`${mensagemInicialFcFormatada}`}
            </h4>
          </div>
        </Box>
      </Box>
      <Box margin="10px">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div style={{ width: "25vw", height: "100%" }}>
            <LabelCaixa tipoCaixa={tipoCaixa} nomeCaixa={nomeCaixa} />
          </div>
          <div style={{ width: "30vw", height: "100%" }}>
            <LabelTeclasAtalho fontSize="15px" grid={getLabelsAtalhos()} />
          </div>
        </div>
      </Box>
      {getUserId() === 1 && false ? (
        <Button
          color="secondary"
          variant="contained"
          onClick={() => {
            history.push("/vendas_editar/frentedecaixa");
          }}
          tabindex="-1"
        >
          {`lalalala)`}
        </Button>
      ) : null}
      <MenuMaisOpcoes
        ref={menuRef}
        saldoIndicadorRetirada={saldoIndicadorRetirada}
        changeModoOffline={changeModoOffline}
      />
      <DialogoContadorCedulas
        ref={refDialogoContadorCedulas}
        handleClose={() => updateSaldo()}
        handleSalvar={novaRetirada}
        getTitle={(total) => `Nova retirada, Total = ${formatMoeda(total)}`}
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoConfirmacao
        ref={dialogoLogoutRef}
        handleConfirma={() => logoutTask()}
        isInput
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoConfirmacao
        ref={refDialogoNovaVendaRascunho}
        handleConfirma={handleConfirmaNovaVendaComRascunho}
        isInput
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoTrocoEntrada
        ref={refDialogoTrocoEntrada}
        handleSalvar={handleTrocoEntrada}
        openConsultorPrecos={openConsultorPrecos}
        usar_biometria={usar_biometria}
      />
      <DialogoRetirada
        ref={refDialogoRetirada}
        handleSalvar={novaRetirada}
        handleClose={() => updateSaldo()}
        getTitle={(total) => `Nova retirada, Total = ${formatMoeda(total)}`}
        openConsultorPrecos={openConsultorPrecos}
        usar_biometria={usar_biometria}
      />
      <DialogoAutorizacaoRetirada
        ref={refDialogoSenha}
        handleClose={() => {}}
        enqueueSnackbar={enqueueSnackbar}
        handleCancelar={() => {}}
        handleSalvar={(user_id) => {
          setResponsavelId(user_id);
          if (refDialogoContadorCedulas.current) {
            refDialogoContadorCedulas.current.handleOpen();
          }
        }}
        mensagemSucesso="Retirada autorizada!"
        title="Autorização retirada!"
        openConsultorPrecos={openConsultorPrecos}
        usar_biometria={usar_biometria}
      />
      <DialogoSenha
        ref={refDialogoSenha2}
        handleClose={() => {}}
        enqueueSnackbar={enqueueSnackbar}
        handleCancelar={() => {}}
        handleSalvar={(codigo) => {
          logoutTaskExec();
        }}
        mensagemSucesso="Logout realizado!"
        title="Autorização logout!"
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoAutorizacaoComQrcode
        ref={refDialogoAutorizacaoComQrcode}
        handleClose={() => {}}
        enqueueSnackbar={enqueueSnackbar}
        handleSalvar={() => {
          dialogoAutorizacaoConfig.handleSalvar();
        }}
        mensagemSucesso={dialogoAutorizacaoConfig.mensagemSucesso}
        title={dialogoAutorizacaoConfig.title}
        openConsultorPrecos={openConsultorPrecos}
        usar_biometria={usar_biometria}
      />
      <DialogoVideosTutoriais
        ref={refDialogoVideosTutoriais}
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoPagarDescarregoMercadoria
        ref={refDialogoPagarDescarregoMercadoria}
        handleSalvar={handlePagarDescarregoMercadoria}
      />
      <DialogoComunicacaoSitef
        ref={refDialogoComunicacaoSitef}
        interfaceSitef={interfaceSitef}
        handleResposta={(
          item,
          message,
          data,
          isReimpressao,
          isCancelamento,
          isMenuAdministrativo
        ) => {
          if (isMenuAdministrativo) {
            if (data) {
              imprimirComprovanteTef(data);
            }
          } else {
            if (isReimpressao) {
              if (data) {
                imprimirComprovanteTef(data);
                if (isCancelamento) {
                  salvarComprovanteTefCancelamentoTransacao(data);
                }
              }
            }
          }

        }}
        CupomFiscal={""}
        DataFiscal={""}
      />
      <DialogoTratamentoTEFPendentes 
        ref={refDialogoTratamentoTEFPendentes} 
        processando={pendenciasTEFResolvidas}
      />
      <KeyboardEventHandler
        handleKeys={[
          NOVA_VENDA_ACTION,
          CARREGAR_VENDA_SALVA_ACTION,
          NOVA_RETIRADA_ACTION,
          OPEN_MENU_ACTION,
          LOGOUT_ACTION,
          CONSULTOR_PRECOS_ACTION,
          NOVA_PREVENDA_ACTION,
          NOVO_DEPOSITO_ACTION,
          DESCONECTAR_SESSAO_ACTION,
          ESC_ACTION,
          PAGAR_DESCARREGO_MERCADORIA_ACTION,
          REIMPRIMIR_ULTIMO_CUPOM,
          IMPRIMIR_ULTIMO_CUPOM_TEF_ACTION,
          IMPRIMIR_CUPOM_ESPECIFICO,
          CANCELAR_TRANSACAO_TEF,
          MENU_ADMINISTRATIVO_TEF,
        ]}
        onKeyEvent={(key) => handleActions(key)}
      />
      <DialogoStatusImpressao
        ref={refDialogoStatusImpressao}
      />
    </>
  );
};

export default Init;
